var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1992 1058",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-981.636 831.753V929.651V1004.66H1809.8V983.049V961.436H1596.05V895.323L1486.63 860.995V549.502L1458.64 539.331V499.917L1400.12 463.047L1233.44 485.932V539.331L1209.27 541.873V831.753H1108.76V53.6556L999.341 -15L675.481 53.6556V862.266H635.462V620.7L477.696 552.045L425.532 582.558V813.953H405.175V72.7266L349.194 16.785L127.813 53.6556V831.753H69.287V189.696L14.8845 127.686L-187.718 276.151V681.728H-215.709V422.362L-324.138 366.257L-405.282 382.948V560.944L-449.813 532.974L-645.748 560.944V857.181H-690.278H-734.809V681.728H-841.682V871.166H-881.124V913.122H-919.293V831.753H-981.636Z",
    fill: "#106DB4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1257.97 569.443L1235.14 570.839V617.385L1257.97 615.989V569.443Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1257.97 637.932L1235.14 639.328V685.874L1257.97 684.478V637.932Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1257.97 706.421L1235.14 707.818V754.364L1257.97 752.967V706.421Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1317.32 562.594L1294.49 563.99V610.536L1317.32 609.14V562.594Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1317.32 631.083L1294.49 632.479V679.026L1317.32 677.629V631.083Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1317.32 699.572L1294.49 700.969V747.515L1317.32 746.118V699.572Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.68 555.745L1353.85 557.141V603.687L1376.68 602.291V555.745Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1376.68 624.234L1353.85 625.63V672.177L1376.68 670.78V624.234Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.68 692.723L1353.85 694.12V740.666L1376.68 739.27V692.723Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M738.588 94.5828L714.617 99.1487V213.298L738.588 207.59V94.5828Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.305 236.128L712.334 240.694V354.842L736.305 349.135V236.128Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.588 379.955L714.617 384.521V498.67L738.588 492.963V379.955Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.588 532.915L714.617 537.481V651.63L738.588 645.922V532.915Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.38 85.451L769.409 90.017V204.166L793.38 198.458V85.451Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.097 226.996L767.125 231.562V345.71L791.097 340.003V226.996Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.38 370.823L769.409 375.389V489.538L793.38 483.831V370.823Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.38 523.783L769.409 528.349V642.498L793.38 636.79V523.783Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.171 74.036L824.2 78.602V192.751L848.171 187.043V74.036Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.888 215.581L821.917 220.147V334.296L845.888 328.588V215.581Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.171 359.408L824.2 363.974V478.123L848.171 472.416V359.408Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.171 512.368L824.2 516.934V631.083L848.171 625.375V512.368Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.963 62.6211L878.991 67.1871V181.336L902.963 175.629V62.6211Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.68 204.166L876.708 208.732V322.881L900.68 317.173V204.166Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.963 347.993L878.991 352.559V466.708L902.963 461.001V347.993Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.963 500.953L878.991 505.519V619.668L902.963 613.961V500.953Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.32 51.2063L938.349 55.7723V169.921L962.32 164.214V51.2063Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.037 192.751L936.066 197.317V311.466L960.037 305.758V192.751Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.32 336.579L938.349 341.145V455.293L962.32 449.586V336.579Z",
    fill: "#FBCC96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.32 489.538L938.349 494.104V608.253L962.32 602.546V489.538Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.57 834.268V49.4539L174.693 46.6405V828.561L157.57 834.268Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.381 827.419V43.0024L213.504 40.1482V821.711L196.381 827.419Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.192 820.57V36.5616L252.315 33.6794V814.863L235.192 820.57Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.002 813.721V30.0621L291.125 27.2351V808.013L274.002 813.721Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.964 809.155V24.7524L323.086 21.8933V803.448L305.964 809.155Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8535 850.871V127.686L69.6288 188.72V850.871H14.8535Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.93 1005.49V514.651L1488.55 534.758L1487.45 1005.49H1410.93Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.667 863.947L349.34 14.6787L408.698 71.5103L405.561 863.947H349.667Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.707 850.249V-15L1111.86 50.2621V838.67L997.707 850.249Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.47 863.947V551.179L424.678 581.797V863.947H479.47Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.04 516.952V463.23L1459.03 500.098V546.447L1400.04 516.952Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.018 623.093V586.565L591.337 623.093V658.479L500.018 623.093Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.018 681.308V644.781L591.337 681.308V716.695L500.018 681.308Z",
    fill: "#FBCC96"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M500.018 740.666V704.138L591.337 740.666V776.052L500.018 740.666Z",
    fill: "#005596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.06 929.012H1537.84V952.983H-991.555H-1087.17V1003.21H-1133.89V877.645H-1284.91V1003.21H-1422.9V952.983H-1441.37V1003.21H-1533.72V983.803H-1572.84V1003.21H-1796.66V1058H2376.63V1020.33H1944.19H1754.06V929.012Z",
    fill: "#106DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.96 681.308L1662.66 637.932H1614.11V968.964H1741.96V681.308Z",
    fill: "#106DB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1229.14,
    y: 563.443,
    width: 36.8298,
    height: 61.9426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.8 0 0 0 0 0.588235 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 1229.14,
    y: 700.421,
    width: 36.8298,
    height: 61.9426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.8 0 0 0 0 0.588235 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 1288.49,
    y: 556.594,
    width: 36.8298,
    height: 61.9426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.8 0 0 0 0 0.588235 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 1288.49,
    y: 625.083,
    width: 36.8298,
    height: 61.9426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.8 0 0 0 0 0.588235 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 1347.85,
    y: 549.745,
    width: 36.8298,
    height: 61.9426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.8 0 0 0 0 0.588235 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 1347.85,
    y: 686.723,
    width: 36.8298,
    height: 61.9426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.8 0 0 0 0 0.588235 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 703.334,
    y: 42.2063,
    width: 267.986,
    height: 618.423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.956933 0 0 0 0 0.730833 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 491.018,
    y: 577.565,
    width: 109.319,
    height: 89.9138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.956933 0 0 0 0 0.730833 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 491.018,
    y: 635.781,
    width: 109.319,
    height: 89.9138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.956933 0 0 0 0 0.730833 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 166.131,
    y1: 46.6405,
    x2: 166.131,
    y2: 834.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE872",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE872",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 204.943,
    y1: 40.1482,
    x2: 204.943,
    y2: 827.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE872",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE872",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 243.754,
    y1: 33.6794,
    x2: 243.754,
    y2: 820.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE872",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE872",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 282.564,
    y1: 27.2351,
    x2: 282.564,
    y2: 813.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE872",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE872",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 314.525,
    y1: 21.8933,
    x2: 314.525,
    y2: 809.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE872",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE872",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/Buildings.54f8fe8a.svg";
export { ForwardRef as ReactComponent };